module.exports = __webpack_public_path__ + "img/about_logo_14.ed25468f.png";